// src/pages/Redirect.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSession } from '../context/SessionContext';

const Redirect: React.FC = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useSession();

  useEffect(() => {
    if (!user || isLoading) return;

    // Example role-based routing
    switch (user.role) {
      case 'Admin':
      case 'Support':
      case 'Client':
      case 'Client Plus':
      case 'Syndication Partner':
        navigate('/vehicles');
        break;
      case 'Billing':
        navigate('/billing');
        break;
      case 'Auditor':
        navigate('/vehicles');
        // navigate('/reporting');
        break;
      default:
        navigate('/not-authorized');
    }
  }, [user, isLoading, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Redirect;
